import React, { useState, useEffect } from "react";
import { MSG } from "../constants/toastMessages";
import AdminHeader from '../layout/AdminHeader';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { apiCallingPost } from "../api/services"
import noData from "../assets/images/no-data.png"
import Loader from "../assets/images/loader.gif"
import { FiSearch, FiPlus } from "react-icons/fi";
import '../assets/css/admin-toolbar.css';
import { RiDeleteBinLine } from "react-icons/ri";
import { MdOutlineEdit } from "react-icons/md";
import Pagination from "react-js-pagination";
import AddAdmin from './admin-add';
import { toast } from 'react-toastify';

function AdminList() {
  const { isAuthenticated } = useSelector((state) => state.authentication);
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0)
  const [itemsCountPerPage, setItemsCountPerPage] = useState(10)
  const [userList, setUserList] = useState([])
  const [userTotalCount, setUserTotalCount] = useState(0)
  const [userName, setUserName] = useState("")
  const [loading, setLoading] = useState(false)
  const [mode, setMode] = useState("")
  const [selectedAdmin, setSelectedAdmin] = useState([])
  const [activePage, setActivePage] = useState(1)
  const [addAdminFlag, SetAddAdminFlag] = useState(false)
  const [isDelete, setIsDelete] = useState(false)
  const [selectedToDelete, setSelectedToDelete] = useState(null);
  const [isChangedRoleId, setIsChangedRoleId] = useState(false);
  const [saveFlag, setSaveFlag] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      window.location.href = "/login"
    }

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        cancelPopup();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    setOffset(0);
    setActivePage(1);
    userListFn(userName, 0);
  }, [itemsCountPerPage])
  const userListFn = async (userName, offsetNo) => {
    setLoading(true)
    let postData = {
      userId: "",
      userName: userName,
      offset: offsetNo,
      max: itemsCountPerPage,
      roleId: "2"
    }
    try {
      const response = await apiCallingPost("api/user/userList", postData);

      const { data } = response;
      if (data.success === "1") {
        // setUserList(data.result)
        setUserTotalCount(Number(data.totalCount))
        const list = data.result.map(u => ({ ...u, originalRoleId: u.role_id }));
        setUserList(list);
        // setChangedRoleId()
      }
      else {
        setUserList([])
        setUserTotalCount(0)
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
      setUserList([]);
      setUserTotalCount(0)
    } finally {
      setLoading(false);
    }
  }
  const viewDetails = (data) => {
    navigate("/media-list", {
      state: data.user_id
    })
  }

  const handlePageChange = (pageNumber) => {
    setLoading(true);
    let offsetNo = (pageNumber - 1) * itemsCountPerPage;
    setOffset(offsetNo);
    setActivePage(pageNumber);
    userListFn(userName, offsetNo);
  }

  const deleteAdmin = async (data) => {
    // if (window.confirm("Do you want to delete?")) {
    if (!selectedToDelete) return;

    const milliseconds = new Date().getTime();
    setSaveFlag(true)
    let postData = {
      updated_on: milliseconds,
      id: selectedToDelete.user_id
    }
    try {
      const { data } = await apiCallingPost("api/authentication/userDelete", postData);

      if (data.success === "1") {
        toast.success(MSG.adminDeleted);
        setTimeout(() => {
          setSaveFlag(false)
        }, 700);
        // IdP (Firebase) auth record is now removed server-side by userDelete — no separate call needed.
        let offsetCount = 0
        if ((userTotalCount - 1) > ((activePage - 1) * itemsCountPerPage)) {
          offsetCount = offset
        }
        else {
          setActivePage(activePage - 1)
          offsetCount = offset - itemsCountPerPage
        }
        setOffset(offsetCount)
        setTimeout(() => {
          userListFn(userName, offsetCount);
        }, 1000);
      }
      else {
        toast.error(MSG.genericError);
      }

    } catch (error) {
      console.error("Error Delete Admin:", error);
    }
    // }
    cancelpopup();
  }
  const addAdminFn = (mode, data) => {
    setSelectedAdmin(data)
    setMode(mode)
    SetAddAdminFlag(true)
  }

  const cancelPopup = () => {
    SetAddAdminFlag(false)
    document.body.style.overflow = 'auto';
  }
  const cancelpopup = () => {
    setIsDelete(false)
    setSelectedToDelete(null);
  }
  const handleRoleChange = (index, newRoleId, data) => {
    if (data.role_id == newRoleId) {
      setIsChangedRoleId(false)
    } else {
      setIsChangedRoleId(true)
      const updatedList = [...userList];
      updatedList[index].role_id = newRoleId;
      setUserList(updatedList);
    }


    // you can also call an API to update role here
    // await fetch(`/api/users/${updatedList[index].id}/role`, { method:"PUT", body: JSON.stringify({roleId:newRoleId}) })
  };
  const confirmRoleChange = async (data) => {
    let postData = {
      "role_id": data.role_id,
      "user_id": data.user_id
    }

    try {
      const { data } = await apiCallingPost("api/authentication/change_role", postData);

      if (data.success === "1") {
        toast.success(MSG.roleChanged);
        userListFn(userName, offset);

      }
      else {
        toast.error(MSG.genericError);
      }
    } catch (error) {
      console.error("Error Delete Admin:", error);
    }
  }
  return (
    <div className='main-wrapper main-wrapper-cms'>
      <AdminHeader title="Admin List" />
      <div className="admin-toolbar">
        <div className="container">
        <div className="admin-toolbar-search">
          <FiSearch className='search-input-icon' />
          <input type='text' className='search-input' placeholder='Name / Email / Mobile / Company Search'
            onChange={(e) => {
              setUserName(e.target.value)
              if (e.target.value === "") {
                userListFn(e.target.value, 0)
              }
              else if (e.target.value.length >= 3) {
                userListFn(e.target.value, 0)
              }
            }} />
        </div>
        <div className="admin-toolbar-actions">
          <button onClick={() => addAdminFn("Add", "")} className="accept-all-btn"><FiPlus /> Add Admin</button>
        </div>
        </div>
      </div>
      <div className="container mt-4">
        {isDelete &&
          <div className="modal-admin-wrapper multiple-upload" >
            <div className="modal-ad-popup modal-md">
              <div className="modal-innerpopup ">
                <div className="modal-headdiv d-flex justify-content-between">
                  <h5 className="modal-head w-100 text-center">Do you want to delete?</h5>
                  {/* <span className="closeBtn"><IoCloseOutline size={32} onClick={() => cancelpopup()} /></span> */}
                </div>
              </div>
              <div className="tag-popup-footer">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="accept-all-btn w-100 py-2 accept-all-gray"
                    onClick={() => cancelpopup()}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    disabled={saveFlag}
                    className="accept-all-btn w-100 py-2 d-flex align-items-center gap-2 justify-content-center"
                    onClick={() => deleteAdmin()}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>}
        <div className='table-responsive'>
          {!loading ? (
            userTotalCount > 0 ? (
              <>
                <table className="table table-bordered admin-list-table">
                  <thead>
                    <tr>
                      <th className='text-center'>#</th>
                      <th>Name</th>
                      <th className='text-center'>Company Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th className='text-center'>Date</th>
                      <th className='text-center' style={{ width: "280px" }}>Role</th>
                      <th className='text-center'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {userList.map((data, i) => (
                      <tr key={data.id}>
                        <td className='text-center'>{(offset * 1) + i + 1}</td>
                        <td>
                          <div>{data.display_name}</div>
                          {data.isVideoAvailable === 1 &&
                            <button className='Modified'>Modified</button>
                          }
                        </td>
                        <td style={{ whiteSpace: 'nowrap' }} className='text-center'>{data.companyName}</td>
                        <td>{data.email_id}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{data.mobile_number ? `${data.countryCode ?? ''} ${data.mobile_number}`.trim() : ''}</td>
                        <td className='text-center' style={{ whiteSpace: 'nowrap' }}>{moment(Number(data.created_on)).format('DD-MM-YYYY')}</td>
                        {/* <td className='text-center' style={{whiteSpace:'nowrap'}}>
                          <span onClick={() => viewDetails(data)} className='view-deatils-list'>
                            View Details
                          </span>
                        </td> */}
                        <td className='text-center'>
                          <select className="open" value={data.role_id} style={{ fontSize: "12px", width: "100px" }} onChange={(e) => handleRoleChange(i, e.target.value, data)}>
                            <option value="1">SUPER ADMIN</option>
                            <option value="2">ADMIN</option>
                            <option value="4">APPROVER</option>
                            {/* <option value="3">USER</option> */}
                          </select>

                          {data.role_id !== data.originalRoleId && (
                            <button className="accept-all-btn ms-2" onClick={(e) => confirmRoleChange(data)}>Confirm</button>)}
                        </td>
                        <td className='text-center'>
                          {/* <MdOutlineEdit className='theme-color cursor-pointer mt-2' size={20}
                            onClick={() => addAdminFn("Edit", data)} /> */}

                          <RiDeleteBinLine className='text-danger cursor-pointer mt-2 ms-3' size={17}
                            // onClick={() => deleteAdmin(data)}
                            onClick={() => {
                              setSelectedToDelete(data);
                              setIsDelete(true)
                              // window.scrollTo({ top: 0, behavior: 'smooth' });                              
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="d-flex align-items-center gap-3 flex-wrap justify-content-end  my-4 page-division">

                  <div className="ms-auto d-flex align-items-center  gap-3 flex-wrap">
                    <div className="d-flex align-items-center gap-2">
                      Rows per page:
                      <select value={itemsCountPerPage} style={{ minWidth: '60px' }} onChange={(e) => setItemsCountPerPage(e.target.value)}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>

                      </select>
                    </div>
                    {(Number(userTotalCount) > Number(itemsCountPerPage)) ?
                      <div className='pagination-wrapper m-0 p-0'>
                        <Pagination
                          activePage={activePage}
                          itemsCountPerPage={itemsCountPerPage}
                          totalItemsCount={userTotalCount}
                          pageRangeDisplayed={5}
                          onChange={(e) => handlePageChange(e)}
                        />
                      </div>
                      : ""
                    }
                  </div>
                </div>
              </>
            ) : (
              <div className="noData d-flex flex-column">
                <div>
                  <img src={noData} alt="noData" className="img-fluid" width="150" height="150" />
                </div>
                <div>No Data Available</div>
              </div>
            )) : (
            <div className="noData d-flex flex-column">
              <div>
                <img src={Loader} alt="noData" className="img-fluid" width="150" height="150" />
              </div>
            </div>
          )}
        </div>
        {addAdminFlag &&
          <AddAdmin cancelPopup={cancelPopup} userListFn={userListFn}
            selectedAdmin={selectedAdmin} mode={mode} setOffset={setOffset} setActivePage={setActivePage} />
        }
      </div>
    </div>
  )
}

export default AdminList